import { render, staticRenderFns } from "./DateTime.vue?vue&type=template&id=2770b889&"
import script from "./DateTime.vue?vue&type=script&lang=js&"
export * from "./DateTime.vue?vue&type=script&lang=js&"
import style0 from "./DateTime.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports